var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilesBlue = function SvgFilesBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "26px",
    viewBox: "0 0 19 26",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Path")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-12-Pro",
    transform: "translate(-55.000000, -794.000000)",
    fill: "#1975FA",
    fillRule: "nonzero",
    stroke: "#1975FA",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.2906451,801.201353 L69.2906451,813.417262 L69.2906451,813.417262 C69.2906451,815.928626 67.2565542,817.962716 64.7451905,817.962716 C62.2338269,817.962716 60.199736,815.928626 60.199736,813.417262 L60.199736,799.212716 C60.199736,797.644535 61.4724633,796.371807 63.0406451,796.371807 C64.6088269,796.371807 65.8815542,797.644535 65.8815542,799.212716 L65.8815542,811.144535 C65.8815542,811.769535 65.3701905,812.280898 64.7451905,812.280898 C64.1201905,812.280898 63.6088269,811.769535 63.6088269,811.144535 L63.6088269,801.201353 C63.6088269,800.730656 63.2272514,800.34908 62.7565542,800.34908 C62.2858569,800.34908 61.9042814,800.730656 61.9042814,801.201353 L61.9042814,811.144535 L61.9042814,811.144535 C61.9042814,812.712716 63.1770087,813.985444 64.7451905,813.985444 C66.3133723,813.985444 67.5860996,812.712716 67.5860996,811.144535 L67.5860996,799.212716 C67.5860996,796.701353 65.5520087,794.667262 63.0406451,794.667262 C60.5292814,794.667262 58.4951905,796.701353 58.4951905,799.212716 L58.4951905,813.417262 C58.4951905,816.871807 61.2906451,819.667262 64.7451905,819.667262 C68.199736,819.667262 70.9951905,816.871807 70.9951905,813.417262 L70.9951905,801.201353 C70.9951905,800.730656 70.613615,800.34908 70.1429178,800.34908 C69.6722206,800.34908 69.2906451,800.730656 69.2906451,801.201353 Z",
    id: "Path",
    transform: "translate(64.745191, 807.167262) rotate(30.000000) translate(-64.745191, -807.167262) "
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilesBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/files_blue.512c4cd4.svg";
export { ForwardRef as ReactComponent };